import { forwardRef, useImperativeHandle, useRef, useCallback } from "react";

export interface BalloonsRef {
  launchAnimation: () => void;
}

interface BalloonsProps {
  type?: "default" | "text";
  text?: string;
  fontSize?: number;
  color?: string;
}

export const Balloons = forwardRef<BalloonsRef, BalloonsProps>(
  ({ type = "default", text, fontSize, color }, ref) => {
    const containerRef = useRef<HTMLDivElement>(null);

    const launchAnimation = useCallback(async () => {
      const { balloons: launchBalloons } = await import("balloons-js");
      launchBalloons();
    }, []);

    useImperativeHandle(ref, () => ({ launchAnimation }), [launchAnimation]);

    return <div ref={containerRef} />;
  }
);

Balloons.displayName = "Balloons";
